//#region IMPORTS
import { HTMLProps, useEffect, useRef } from "react";
import classNames from "../../helpers/classNames";
//#endregion

export default function MainSortableTableCheckBox({
  indeterminate,
  disabled,
  ...rest
}: { indeterminate?: boolean } & HTMLProps<HTMLInputElement>) {
  //#region SETUP
  // Ref
  const ref = useRef<HTMLInputElement>(null!);

  //#endregion

  //#region LOGIC
  useEffect(() => {
    if (typeof indeterminate === "boolean") {
      ref.current.indeterminate = !rest.checked && indeterminate;
    }
  }, [ref, indeterminate, rest.checked]);
  //#endregion

  //#region RENDER
  return (
    <input
      type="checkbox"
      disabled={disabled}
      ref={ref}
      className={classNames(
        disabled
          ? "cursor-default text-slate-200"
          : indeterminate
          ? "cursor-pointer text-amber-500"
          : "cursor-pointer text-slate-600",
        "h-4 w-4 rounded border-gray-300 focus:ring-1 focus:ring-white"
      )}
      {...rest}
    />
  );
  //#endregion
}
